/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Projects_Create_DescInputs */



/**
* | output |
* | --- |
* | "Allows creating new projects." |
*
* @param {Rights_Cap_Projects_Create_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_projects_create_desc = /** @type {((inputs?: Rights_Cap_Projects_Create_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Projects_Create_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt das Erstellen neuer Projekte.")
	return /** @type {LocalizedString} */ ("Allows creating new projects.")
});